module.exports = __webpack_public_path__ + "images/284e4b86dddd1f149b7ef53c5898154b.svg";